import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../shared/material.module';
import { NewsUpdatesPreviewComponent } from './news-updates-preview/news-updates-preview.component';
import { NewsUpdatesDetailsComponent } from './news-updates-details/news-updates-details.component';
import { SolarAnnoucementsComponent } from './dialogs/solar-annoucements/solar-annoucements.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    NewsUpdatesPreviewComponent,
    NewsUpdatesDetailsComponent,
    SolarAnnoucementsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [
    NewsUpdatesPreviewComponent,
    NewsUpdatesDetailsComponent
  ]
})
export class SupplierModule { }
